import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"pa-1",attrs:{"fluid":""}},[_c(VSheet,{attrs:{"tile":"","color":"colorComponentsBackground","height":"340px"}},[_c('WorkplaceInputForm')],1),_c(VRow,[_c(VCol,[_c('WorkplaceTransactions')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }